import React, {MouseEventHandler, ReactElement} from 'react';
import {Button, Icon, MenuItem, SxProps, Theme, Tooltip} from '@mui/material';
import auth from 'services/auth';

export const canShowActionMenuItem = (permission?: string): boolean => !permission || auth.hasPermission(permission);

const ActionMenuItem = (props: ActionMenuItemProps) => {
  const {onClick, label, sx = {}, icon = <Icon />, permission} = props;
  const {variant = 'standalone'} = props;

  if (!canShowActionMenuItem(permission)) {
    return null;
  }

  if (variant === 'standalone') {
    const button = (
      <Button
        size="small"
        onClick={onClick}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 0,
          padding: 0.5,
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
            backgroundColor: 'action.hover'
          }
        }}
      >
        {icon}
      </Button>
    );

    return label ? (
      <Tooltip title={label} placement="top">
        {button}
      </Tooltip>
    ) : (
      button
    );
  }

  return (
    <MenuItem onClick={onClick} sx={{...sx}}>
      {icon}
      {label}
    </MenuItem>
  );
};

export default ActionMenuItem;

export type ActionMenuItemProps = {
  label?: string;
  icon?: ReactElement;
  onSuccess?: () => void;
  callback?: () => void;
  onClick?: MouseEventHandler;
  sx?: SxProps<Theme>;
  variant?: 'cell' | 'standalone';
  permission?: string;
};
